import { Component, ViewEncapsulation, Inject } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';

@Component({
  selector: 'app-dlg-welcome',
  templateUrl: './dlg-welcome.component.pug',
  styleUrls: ['./dlg-welcome.component.less'],
  encapsulation: ViewEncapsulation.None
})
export class DlgWelcomeComponent {

    constructor(
        public dialogRef: MatDialogRef<DlgWelcomeComponent>,

        @Inject(MAT_DIALOG_DATA) public data: any
    ) {
    }

    onNext() {
        this.dialogRef.close(true);
    }

    onCancel() {
        this.dialogRef.close(false);
    }

}
